// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1oE4H","header":"PatientBlock_header__25xb1","label":"PatientBlock_label__32Ofz","option":"PatientBlock_option__3KnG3"};